module.exports = __webpack_public_path__ + "static/media/video-thumbnail.1eb7f752.png";